import { useUserConfig } from '@/features/user-config';
import { useAppSelector } from '@/hooks/redux-hooks';

import { useFeatureFlagsLoaded } from './useFeatureFlagsLoaded';
import { useGlobalLoaderGate } from './useGlobalLoaderGate';
import { useInitialAppQueries } from './useInitialAppQueries';

export const useInitialLoadGate = (isAuthenticated: boolean) => {
  const areFlagsLoaded = useFeatureFlagsLoaded();
  const tripTokenStatus = useAppSelector(state => state.tripToken.status);
  const { isSuccess: isUserConfigLoaded, isError: isUserConfigError } = useUserConfig();

  const isReadyForData = tripTokenStatus === 'fulfilled' && isUserConfigLoaded;
  const { areMarketsDone, areDashboardsDone } = useInitialAppQueries(
    isAuthenticated && isReadyForData
  );

  const isLoading =
    isAuthenticated &&
    (!areFlagsLoaded ||
      tripTokenStatus === 'idle' ||
      tripTokenStatus === 'loading' ||
      (!isUserConfigLoaded && !isUserConfigError) ||
      (isReadyForData && !(areMarketsDone && areDashboardsDone)));

  useGlobalLoaderGate('app-init', isLoading);

  return isLoading;
};
